import React from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import ModalBase from '../../../../common/modal/ModalBase';
import OtherBankContents from '../contents/OtherBankContents';
import { otherBankSelectorState } from '../../../../../data/estimate/common/modal/atom';
import useUpdateInfo from '../../../../../hooks/estimate/common/useUpdateInfo';
import { targetTableInfoState } from '../../../../../data/estimate/common/otherBank/info/atom';
import { paymentWayInfoState } from '../../../../../data/estimate/common/paymentWay/info/selector';

/**
 *  타금융사 할부비교 모달 컴포넌트
 *  */
function OtherBankModal(): JSX.Element {
  // set
  const setSelector = useSetRecoilState<boolean>(otherBankSelectorState);

  // select
  const checkIndex: number = useRecoilValue(paymentWayInfoState({ name: 'selectPaymentWayTable' }));

  // function
  const updateTargetIndex = useUpdateInfo(targetTableInfoState);
  const closeEvent = (): void => {
    document.body.style.overflow = 'auto';
    setSelector(false);
  };
  return (
    <ModalBase
      active={true}
      closeEvent={() => {
        document.body.style.overflow = 'auto';
        updateTargetIndex(checkIndex);
        setSelector(false);
      }}
    >
      <OtherBankContents closeEvent={closeEvent} />
    </ModalBase>
  );
}

export default OtherBankModal;
